import React from 'react';
import { Button } from 'antd';
import styles from '../Chat.module.scss';

interface Props {
  noteText: string;
  setNoteText: (text: string) => void;
  noteSubmitting: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

const NoteComposer: React.FC<Props> = ({
  noteText,
  setNoteText,
  noteSubmitting,
  onSubmit,
  onCancel,
}) => (
  <div className={styles.noteModeWrapper}>
    <textarea
      className={styles.noteTextarea}
      placeholder="Type an activity note..."
      value={noteText}
      onChange={(e) => setNoteText(e.target.value)}
      autoFocus
      disabled={noteSubmitting}
      rows={3}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          onCancel();
        }
        if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
          onSubmit();
        }
      }}
    />
    <div className={styles.noteActions}>
      <Button
        className={styles.noteCancelBtn}
        onClick={onCancel}
        disabled={noteSubmitting}
      >
        Cancel
      </Button>
      <Button
        type="primary"
        className={styles.noteSubmitBtn}
        onClick={onSubmit}
        disabled={!noteText.trim() || noteSubmitting}
      >
        Add note
      </Button>
    </div>
  </div>
);

export default NoteComposer;
